import { render, staticRenderFns } from "./documentos-necessarios.vue?vue&type=template&id=94d9d280"
import script from "./documentos-necessarios.vue?vue&type=script&lang=js"
export * from "./documentos-necessarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports